module.exports = __webpack_public_path__ + "static/moyosore-e27c5dc8c2d6a1c069660d66b3bb0f61.jpg";